module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9tYCC"))).then(() => parcelRequire('d0iPb'));